"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _default = {
  SOCIAL: 'social',
  REVERSE_TIME: 'reverse_time',
  TIME: 'time'
};
exports["default"] = _default;